import React, { useContext } from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import { Button, Avatar } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useDialog } from "../../context/DialogContext";
import PsContext from "../../context";
import { getFileLiveUrl, upperCase, sleep, CUSTOM_ICONS } from "../../utils";
//import ChangeUserPassword from "./changePassword";

const ProfileCard = () => {
  const context = useContext(PsContext);
  const { openDialog } = useDialog(); // Using useDialog for confirmation dialogs
  /*  const [editPassword, setEditPassword] = useState(false); */

  const logoutClick = () => {
    openDialog({
      title: "Confirm",
      message: "Do you want to Logout?",
      onConfirm: () => context.logout(),
    });
  };

  const userPhoto = () => {
    if (
      context.userData?.emp_profile_photo &&
      context.userData.emp_profile_photo.length > 5
    )
      return getFileLiveUrl(context.userData.emp_profile_photo);

    let gender = upperCase(context.userData?.emp_gender);
    return gender === "MALE" ? CUSTOM_ICONS.MAN_256 : CUSTOM_ICONS.WOMAN_256;
  };

  /*  const ChangeUserPassword = () => {
    setViewData(item);
    setEditPassword(true);
  }; */

  return (
    <div className={"user-logins-container"}>
      {/* Profile Picture */}
      <div className="d-flex justify-content-center align-content-center">
        <Avatar
          src={userPhoto()}
          sx={{
            width: 120,
            height: 120,
            border: "3px solid white",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        />
      </div>

      {/* User Info */}
      <Card className="mt-3">
        <Card.Header className="text-uppercase fw-bold">
          Profile Information
        </Card.Header>
        <Card.Body>
          <Row className="mb-2">
            <Col md={4} sm={4} xs={4}>
              <strong>Name:</strong>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                value={context.userData.emp_name}
                readOnly
              />
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md={4} sm={4} xs={4}>
              <strong>Role:</strong>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                value={context.userData.role}
                readOnly
              />
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md={4} sm={4} xs={4}>
              <strong>Mobile:</strong>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                value={context.userData.mobile}
                readOnly
              />
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md={4} sm={4} xs={4}>
              <strong>Email:</strong>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                value={context.userData.email || "N/A"}
                readOnly
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Logout & Lock Buttons */}
      <div className="mt-4 text-center">
        <Button
          size="large"
          variant="contained"
          className="bg-theme me-2"
          startIcon={<LockOutlinedIcon />}
          onClick={logoutClick}
        >
          Logout
        </Button>
        {/*  <Button
          size="large"
          variant="contained"
          className="bg-theme ms-2"
          startIcon={<LockOutlinedIcon />}
          onClick={changePassword}
        >
          Lock
        </Button> */}
      </div>
      {/*  <ChangeUserPassword
        show={editPassword}
        dataSource={viewData}
        onHide={(e) => {
          setEditPassword(false);
          setViewData([]);
        }}
        onSuccess={() => {
          setEditPassword(false);
          setViewData([]);
          loadData();
        }}
      /> */}
    </div>
  );
};

export default ProfileCard;
